// 📄 components/StepMGConnections.tsx
import React from 'react';
import { GeneralsFormData } from '../../../../../services/commerce/integrationService.ts';

interface StepMGConnectionsProps {
  mgEndpointUrl: string;
  mgAuthType: string;
  onChange: (field: keyof GeneralsFormData, value: any) => void;
  isInvalid: boolean;
}

export function StepMGConnections({
  mgEndpointUrl,
  mgAuthType,
  onChange,
  isInvalid
}: StepMGConnectionsProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="bg-purple-500/5 border border-purple-500/10 rounded-xl p-3 space-y-1">
        <span className="text-[10px] font-bold text-purple-400 uppercase tracking-widest block">SAP Integration Suite, Managed Gateway</span>
        <p className="font-mono text-xs text-gray-300">
          <span>Managed Gateway → My Projects → Connection Setup</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-purple-400">2. Setup de Conexiones y Endpoint SOAP/REST</h3>
        <p className="text-sm text-gray-400 mt-1">
          Configura el endpoint del middleware o puerto virtual y el tipo de autenticación utilizado para el envío seguro de documentos cXML/IDoc.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 space-y-4">
        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">
            Endpoint URL (Managed Gateway Target Gateway) <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={mgEndpointUrl}
            onChange={(e) => onChange('mgEndpointUrl', e.target.value)}
            placeholder="ej. https://managedgateway.us.sap.com/cxf/receive"
            className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-purple-500 ${
              isInvalid && !mgEndpointUrl ? 'border-red-500' : 'border-white/10'
            }`}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">Tipo de Autenticación</label>
          <select
            value={mgAuthType || 'Basic'}
            onChange={(e) => onChange('mgAuthType', e.target.value)}
            className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm text-white focus:outline-none focus:border-purple-500"
          >
            <option value="Basic">Basic Authentication (User/Password)</option>
            <option value="Certificate">Certificate-Based Authentication (Client Certificate)</option>
            <option value="OAuth">OAuth 2.0 (Client Credentials Grant)</option>
          </select>
        </div>
      </div>
    </div>
  );
}
